/**
 * Listings API Module
 * Ephemeral availability listings — food, goods, services, mutual aid.
 */

import { api } from './client'

export const listingAPI = {
  // Public — no auth required
  getNearbyListings: (lat, lng, radius = 5, category = '') =>
    api.get('/listings/nearby', { params: { lat, lng, radius, ...(category && { category }) } }),

  // Auth required
  createListing:   (data)   => api.post('/listings', data),
  getMyListings:   ()       => api.get('/listings/mine'),
  fulfillListing:  (id)     => api.patch(`/listings/${id}/fulfill`),
  deleteListing:   (id)     => api.delete(`/listings/${id}`),

  // Request queue (safe contact system)
  requestListing:        (id, data) => api.post(`/listings/${id}/request`, data),
  getIncomingRequests:   ()         => api.get('/listings/requests/incoming'),
  getSentRequests:       ()         => api.get('/listings/requests/sent'),
  updateRequestStatus:   (id, status) => api.patch(`/listing-requests/${id}/status`, { status }),
}

